export const COOKIES_ENABLED = 'cookiesEnabled'
export const SCREEN_LOADING = 'screenLoading'

export const ADDRESS_UPDATE = 'addressUpdate'

export const RENEWAL_PERIOD = 'renewalPeriod'

export const VEHICLE_TYPE = 'vehicleType'

export const MASTER_NUMBER = 'masterNumber'
export const PLATE_NUMBER = 'plateNumber'
export const VIN_SERIAL_NUMBER = 'vinSerialNumber'

export const INSURANCE_COMPANY = 'insuranceCompany'
export const POLICY_NUMBER = 'policyNumber'
export const EFFECTIVE_DATE = 'effectiveDate'
export const EXPIRY_DATE = 'expiryDate'

export const COMMERCIAL_AQUACULTURE = 'commercialAquaculture'
export const FISHING_VESSEL = 'fishingVessel'

export const FULL_NAME = 'fullName'
export const EMAIL_ADDRESS = 'emailAddress'
export const CONFIRM_EMAIL_ADDRESS = 'confirmEmailAddress'
export const PHONE_NUMBER = 'phoneNumber'

export const ADD_RENEWAL_PERIODS = 'addRenewalPeriods'

export const EDIT_PLATE_NUMBER = 'editPlateNumber'
export const ADD_PERMIT = 'addPermit'
export const EDIT_PERMIT = 'editPermit'
export const DELETE_PERMIT = 'deletePermit'

export const EDIT_FROM_CONFIRMATION = 'editFromConfirmation'

export const CLEAR_ALL = 'clearAll'
export const CLEAR_INSURANCE_INFO_ACTION = "clearInsuranceInfoAction"
export const CLEAR_ALL_USER_DATA = 'clearAllUserData'
export const CLEAR_PERMIT_INFO = 'clearPermitInfo'
